var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-app',{attrs:{"id":"inspire","color":"grey"}},[_c('v-content',[_c('router-view')],1),_vm._v(" "),_c('v-footer',{staticClass:"pa-3",attrs:{"color":"white","app":""}},[_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"black--text"},[_vm._v("\n        KNDI © "+_vm._s(new Date().getFullYear())+"\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30e3df0e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 